module.exports = __webpack_public_path__ + "static/img/movie.5a5a4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/movie.png
// module id = 232
// module chunks = 1